export default __webpack_public_path__ + "static/media/referral-share.3e2b4181.png";